

import { Component, Prop, Mixins } from "vue-property-decorator";
import { INotificationItem } from "@/store/modules/notification/interface";
import { Mutation } from "vuex-class";
import { NOTIFICATION_MODULE_NAME } from "@/store/modules/notification";
import IBCountdown from "../IBCountdown/IBCountdown.vue";
import IBPaymentCardActionCaller from "../IBPayment/mixins/IBPaymentCardActionCaller";
import { isImportantNotificationStatus } from '@/store/modules/notification/utils';

@Component({
	components: {
		IBCountdown
	}
})
export default class Toast extends Mixins(
	IBPaymentCardActionCaller
) {

	@Prop({
		type: Object,
		default: () => ({
			text: "",
			status: "success",
			title: '',
			link: ''
		})
	})
	item!: INotificationItem;

	@Mutation("deleteToast", { namespace: NOTIFICATION_MODULE_NAME })
	deleteToast!: (toastId: number) => void;

	onClickAction() {
		if (this.item?.action) {
			this.callAction(this.item.action, [ this.item ]);
		} else {
			this.item.deleteToast
				? this.item.deleteToast()
				: this.deleteToast(this.item?.id || 0);
		}
	}

	linkClicked() {
		if (!this.item?.linkHandler || typeof this.item.linkHandler != 'function') return;

		try {
			this.item.linkHandler(this.item);
		} catch (err) {
			console.warn('Component:Toast -> linkClicked()', err);
		}
	}

	getFormattedRemainingTime(
		remainingTimeInSeconds: number,
		formattedMinutes: string,
		formattedSeconds: string,
	): string {
		const remainingTime = remainingTimeInSeconds
			? `${formattedMinutes}:${formattedSeconds}`
			: '00:00';

		return (this.item.text || "")
			.replace('{remainingTime}', remainingTime);
	}

	get iconClassName(): string {
		if (this.isImportantStatus || this.item?.prependIconUrl)
			return '';

		return this.item?.status === 'success'
			? 'icon-complete-round'
			: 'icon-warning-round';
	}

	get iconImgSrc(): string {
		return this.item?.prependIconUrl
			|| '/img/icons/access-time.svg';
	}

	get actionText(): string {
		return this.item?.actionText || '';
	}

	get toastWidth(): string {
		return this.item?.width
			? `${this.item.width}px`
			: '100%';
	}

	get classNameByStatus(): string {
		return (this.item?.status === 'important_light'
			? 'important important_light'
			: this.item?.status) || '';
	}

	get isImportantStatus(): boolean {
		return isImportantNotificationStatus(this.item?.status);
	}

}

